/* global Stripe */
// Production
const apiKey = process.env.REACT_APP_STRIPE_API_KEY;
//'pk_live_P0FSIEtbwU1GSvgvEM3DYuUZ';

// Staging
// const apiKey = 'pk_test_ESWRIhPFbWs35vmzXZXdyXN5';

Stripe.setPublishableKey(apiKey);

// Production
//Stripe.setPublishableKey('pk_test_ESWRIhPFbWs35vmzXZXdyXN5');


function createToken(d) {
  return new Promise((resolve, reject) =>{
    Stripe.card.createToken(d, (status, response) =>{
      // console.log('Stripe res', status, response);
      if (status === 200) {
        resolve(response);
      } else {
        reject(response.error.message);
      }
    });
  });
}

/**
 * cardData:
 * {
 *   expiration: '6/22',
 *   cvc: '123',
 *   cardNumber: '1234 5678 9012 3456',
 * }
 */
const getPaymentToken = (cardData) => {
  const exp = cardData.expiration.replace(/ /g, '').split(/\//);
  const { cvc, cardNumber:number } = cardData;
  const normalizedCardData = {
    exp_month: parseInt(exp[0], 10),
    exp_year: parseInt(exp[1], 10),
    number,
    cvc
  };
  return createToken(normalizedCardData)
    .then(resp => resp.id);
};

export default getPaymentToken;


// WEBPACK FOOTER //
// ./src/services/stripe.js